import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";

import StatsSceen from "./stats-screen";
import {fetchAllLevelsProperties, fetchAllUserLevels} from "../../ducks/duck-game";
import {secondsToDHM} from '../../helpers/date';
import {getTranslation} from "../../helpers/get-translation";
import MONTHS from "../../constants/MONTHS";

const path = "static/images/stats-screen/";


function StatsScreenContainer(props) {
	const { stats,
		user,
		allLevelPropertiesDownloaded,
		fetchAllLevelsProperties,
		allUserLevelsDownloaded,
		fetchAllUserLevels,
		levelList } = props;

	if(!allLevelPropertiesDownloaded){
		fetchAllLevelsProperties();
	}

	if(!allUserLevelsDownloaded){
		fetchAllUserLevels()
	}

	const getLogos = () => {
		let allRiddles = 0;
		for (let gameType in levelList){
			if(levelList.hasOwnProperty(gameType)){
				const riddles = Math.max.apply(Math, levelList[gameType].map(element => {
					return element.logosTo || 0
				}));
				allRiddles += riddles;
			}
		}

		return [
			{
				name: getTranslation("statistics_guessed_logos"),
				img: `${path}/stats_guessed_logos.png`,
				type: "progress-bar",
				color: '#3292ff',
				currentValue: stats.collectedRiddlesAll,
				maxValue: allRiddles,
			},
			{
				name: getTranslation("statistics_points"),
				img: `${path}/stats_guessed_points.png`,
				type: "progress-bar",
				color: '#58dc6f',
				currentValue: stats.collectedPointsAll,
				maxValue: allRiddles*3,
			},
			{
				name: getTranslation("statistics_guess_tries"),
				img: `${path}/stats_guess_tries.png`,
				type: "number",
				currentValue: stats.wrongGuessCount + stats.collectedRiddlesAll
			},
			{
				name: getTranslation("statistics_perfect_guess"),
				img: `${path}/stats_perfect_guess.png`,
				type: "progress-bar",
				color: '#e52f53',
				currentValue: stats.perfectGuessCount,
				maxValue: stats.collectedRiddlesAll,
				isLast: true
			},
		];
	};

	const getLevels = () => {
		let levelCount = 0;
		let unlockedLevelCount = 0;
		let fullCompleteLevel = 0;

		for (let gameType in levelList){
			if(levelList.hasOwnProperty(gameType)){
				levelCount += levelList[gameType].length;
				unlockedLevelCount += levelList[gameType].filter(element => element.collectedPoints !== undefined).length;

				fullCompleteLevel += levelList[gameType]
					.filter(element => element.collectedRiddles === element.logosTo - element.logosFrom + 1)
					.length

			}
		}

		return [
			{
				name: getTranslation("statistics_unlocked_levels"),
				img: `${path}/stats_levels_unlocked.png`,
				type: "progress-bar",
				color: '#5dd6c9',
				currentValue: unlockedLevelCount,
				maxValue: levelCount,
			},
			{
				name: getTranslation("statistics_full_complete"),
				img: `${path}/stats_levels_complete.png`,
				type: "progress-bar",
				color: '#9fe5ff',
				currentValue: fullCompleteLevel,
				maxValue: unlockedLevelCount,
				isLast: true
			},
		];
	};

	const getHints = () => {
		return [
			{
				name: getTranslation("statistics_unused_hints"),
				img: `${path}/stats_all_hints.png`,
				type: "number",
				currentValue: user.hintCount
			},
			{
				name: getTranslation("statistics_used_hints"),
				img: `${path}/stats_used_hints.png`,
				type: "progress-bar",
				color: '#bdac90',
				currentValue: user.usedHintCount,
				maxValue: user.hintCount + user.usedHintCount,
				isLast: true
			},
		];
	};

	const getOther = () => {
		const d = new Date(user.accountCreationDate.getTime());
		const accountCreationDate = d.getDate()  + " " + MONTHS[(d.getMonth())] + " " + d.getFullYear();

		const difference = (new Date(Date.now()) - d) / 1000;
		// const timeArray = secondsToDHMS((new Date('December 18, 1995 02:03:04') - new Date('December 17, 1995 00:00:00')) / 1000).split(':');
		const timeArray = secondsToDHM(difference);

		return [
			{
				name: getTranslation("statistics_first_run"),
				img: `${path}/stats_install_time.png`,
				type: "text",
				text: <span>{getTranslation("statistics_first_run")} <b>{accountCreationDate}</b></span>
			},
			{
				name: getTranslation("statistics_app_since"),
				img: `${path}/stats_live_app_in_days.png`,
				type: "text",
				isLast: true,
				text: <span>
					<span>{getTranslation("statistics_app_since")} </span>
					<b>{timeArray[0]}</b>{getTranslation("statistics_app_since_days")}
					<b> {timeArray[1]}</b>{getTranslation("statistics_app_since_hours")}
					<b> {timeArray[2]}</b>{getTranslation("statistics_app_since_minutes")}
				</span>
			},
		];
	};

	const options = { getLogos, getLevels, getHints, getOther };

	return <StatsSceen  {...props} {...options} />;
}

StatsScreenContainer.propTypes = {
	allLevelPropertiesDownloaded: PropTypes.bool.isRequired,
	allUserLevelsDownloaded: PropTypes.bool.isRequired,

	user: PropTypes.object.isRequired,
	stats: PropTypes.object.isRequired,
	levelList: PropTypes.object.isRequired,

	fetchAllLevelsProperties: PropTypes.func.isRequired,
	fetchAllUserLevels: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
	return {
		stats: state.userReducer.stats,
		user: state.userReducer.user,
		allLevelPropertiesDownloaded: state.gameReducer.allLevelPropertiesDownloaded,
		allUserLevelsDownloaded: state.gameReducer.allUserLevelsDownloaded,
		levelList: state.gameReducer.levelList,
	};
}

export default connect(mapStateToProps, { fetchAllLevelsProperties, fetchAllUserLevels })(StatsScreenContainer);
